"use client";

import * as React from "react";
import { CopyButton } from "@/components/ui/copy-button";
import { cn } from "@/utils/utils";

interface ComponentDemoProps {
  children: React.ReactNode;
  code?: string;
  className?: string;
}

export function ComponentDemo({
  children,
  code,
  className,
}: ComponentDemoProps) {
  return (
    <div className={cn("my-8 flex flex-col gap-4 max-h-[calc(100vh-200px)]", className)}>
      {/* Preview Section */}
      <div className="flex flex-shrink-0 w-full items-center justify-center rounded-md border bg-background p-8 min-h-[200px]">
        {children}
      </div>
      
      {/* Code Section */}
      {code && (
        <div className="relative flex-1 rounded-md border min-h-0 flex flex-col">
          <div className="absolute right-2 top-2 z-10">
            <CopyButton text={code} />
          </div>
          <pre className="overflow-x-auto overflow-y-auto rounded-md bg-muted p-4 pr-12 text-sm flex-1 min-h-0">
            <code className="font-mono">{code}</code>
          </pre>
        </div>
      )}
    </div>
  );
}

